export const getLinkAndTextTypeOfLesson = ({lesson})=>{
        if(!lesson || !lesson?.lesson_name || !lesson?.type) {
            return null;
        }
        switch (lesson?.type) {
            case 'probe': return {
                link: `/v2/courses/my/course-or-group-${lesson?.group_id ?? lesson?.direction_id ?? ''}/block-${lesson?.block_id ?? ''}/topic-${lesson?.theme_id ?? ''}`,
                textType: `Пробник: `,
                name: lesson?.lesson_name
            }
            case 'control': return {
                link: `/home-work/control-${lesson?.block_id ?? ''}`,
                textType: `Контрольная: ` ,
                name: lesson?.lesson_name,
            }
            default: return {
                link: `/v2/courses/my/course-or-group-${lesson?.group_id ?? lesson?.direction_id ?? ''}/block-${lesson?.block_id ?? ''}/topic-${lesson?.theme_id ?? ''}`,
                textType: `Урок: `,
                name: lesson?.lesson_name
            }
        }
}